import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const RTL_LANGUAGES = ["ar", "ur"];

export const useIsRTL = () => {
  const { i18n } = useTranslation();
  return RTL_LANGUAGES.includes(i18n.language);
};

const useRTL = () => {
  const isRtl = useIsRTL();

  useEffect(() => {
    const dir = isRtl ? "rtl" : "ltr";
    document.body.dir = dir;
    document.documentElement.dir = dir;
  }, [isRtl]);

  return isRtl;
};

export default useRTL;
